import styled, { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex, Text as TextBase } from 'Components/UI'

export const Container = styled(Flex)`
  justify-content: center;
  width: 100%;
  border: 1px solid rgba(151, 151, 151, 0.3);
  background-color: #f2f2f2;
`
export const Content = styled(Flex)`
  width: 100%;
  position: relative;
  justify-content: center;
  align-items: flex-start;

  @media screen and (max-width: ${themeGet('breakpoints.1')}) {
    flex-direction: column;
    align-items: center;
  }
`

export const Block = styled(Flex).attrs({
  mx: [24, 36],
})`
  flex-direction: column;
  color: ${themeGet('colors.deepCove')};
  z-index: 1;
  align-items: ${props => (props.single ? 'flex-start' : 'center')};
  @media screen and (min-width: ${themeGet('breakpoints.1')}px) {
    max-width: ${props => (props.single ? '480' : '332')}px;
  }
`

export const VerticalSplitter = styled(Flex)`
  position: absolute;
  background-color: ${themeGet('colors.deepCove')};
  z-index: 1;
  top: 7%;
  left: 50%;
  height: 86%;
  width: 1px;
  @media screen and (max-width: ${themeGet('breakpoints.1')}) {
    top: calc(50% - 8px);
    left: 7%;
    height: 1px;
    width: 86%;
  }
`

const userContainerSingleCss = ({ single }) =>
  single &&
  css`
    flex-direction: row;
    max-width: 664px;
  `

export const UserContainer = styled(Flex)`
  flex-direction: column;
  width: 100%;
  max-width: 404px;

  ${userContainerSingleCss};
`

export const UserSubtitle = styled(TextBase).attrs({
  fontSize: [0, 1, 1, 2],
  mt: '12px',
})`
  font-weight: 300;
`

export const UserName = styled(TextBase).attrs({
  fontSize: [1, 2, 2, 3],
})`
  font-weight: 300;
`

export const UserPosition = styled(TextBase).attrs({
  fontSize: [0, 0, 0, 1],
  my: '12px',
})`
  font-weight: 300;

  text-decoration: underline;
`

export const UserDescription = styled(TextBase).attrs({
  fontSize: [0, 0, 0, 1],
  mb: '16px',
})`
  width: 100%;
  letter-spacing: 0;
  font-weight: 300;
  text-align: justify;
  @media screen and (min-width: ${themeGet('breakpoints.1')}) {
    text-align: ${props => (props.single ? 'justify' : 'center')};
  }
`

export const UserPhoto = styled.img`
  width: 112px;
  height: 112px;
  margin: 16px 0;
  border-radius: 50%;
  object-fit: cover;
  align-self: center;
  display: ${props => (props.hide ? 'none' : 'block')};
  z-index: 1;
`
